import Model from './Model'

export default class File extends Model
{

    static async get (fileId) {
        const { data } = await Http.get(route('api.v1.files.show', fileId))

        return data.data
    }

    get downloadUrl () {
        return this._links.download
    }

    get inlineUrl () {
        return this._links.inline
    }

    get viewUrl () {
        return this._links.view
    }

    getPreviewObject(){
        return {
            name: this.filename,
            previewable: this.has_preview,
            type: 'file',
            icon: this.icon,
            previewUrl: this.big_preview_url,
            downloadUrl: this.image_url,
            deleteUrl: this._links.delete,
            createdAt: this.created_at,
            createdBy: this.created_by,
            size: this.filesize,
        }
    }

}
